module.exports = __webpack_public_path__ + "img/06.3dfcd538.png";